









import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import MenuItem from '@pjn/core/model/app/MenuItem';
import { byId } from '@pjn/utils/array';
import Themeable from '../Themeable';

/**
 * Menu de Toolbar Extendido
 */
@Component
export default class ToolbarExtendedMenu extends Mixins(Themeable) {

  /** Items del menu */
  @Prop({ type: Array, default: () => [] })
  items: MenuItem[];

  /** Item seleccionado del menu */
  @Prop() selected: MenuItem;

  get selectedIndex() {
    if(!this.items || !this.selected) return -1;
    return this.items.findIndex(byId(this.selected.id));
  }

  onItemClick(item: MenuItem) {
    this.$emit('itemClick', item);
  }
}
